import React from "react";

import { Chip, Stack, Typography } from "@mui/material";
import { usePrompt } from "hooks";

import { useEmailsContext } from "../context/Email-context";
import { EmailInboxFilter, FilterKind } from "../EmailInbox";
import { FilterContent } from "./FilterContent";

interface Props {}

export const Filters: React.FC<Props> = () => {
  const { filter, onFilterChange } = useEmailsContext();
  const openPrompt = usePrompt();
  const onFilterChipClick = async (kind: FilterKind, anchorEl: HTMLElement, filter: EmailInboxFilter) => {
    const data = await openPrompt({
      Component: FilterContent,
      componentType: "popover",
      anchorEl: anchorEl,
      props: {
        kind,
        filter
      }
    });
    if (!data?.isSubmitted) return;
    onFilterChange({ ...filter, [kind]: data.data || null });
  };

  return (
    <Stack direction="row" alignItems="center" gap="10px">
      <Typography sx={{ color: "#071F35", fontSize: "14px", fontWeight: "400" }}>Filter :</Typography>
      <Chip
        sx={{ height: "24px", cursor: "pointer", fontSize: "12px" }}
        onClick={(e) => onFilterChipClick(FilterKind.DEAL, e.currentTarget, filter)}
        label={`Deal Name (${filter?.deal?.length || 0})`}
      />
      <Chip
        sx={{ height: "24px", cursor: "pointer", fontSize: "12px" }}
        onClick={(e) => onFilterChipClick(FilterKind.ASSOCIATION, e.currentTarget, filter)}
        label={`Association (${filter?.association ? 1 : 0})`}
      />
      <Chip
        sx={{ height: "24px", cursor: "pointer", fontSize: "12px" }}
        onClick={(e) => onFilterChipClick(FilterKind.ATTACHMENT, e.currentTarget, filter)}
        label={`Attachment (${filter?.attachment ? 1 : 0})`}
      />
      <Typography
        onClick={() => onFilterChange({ deal: [], association: null, attachment: null })}
        sx={{ color: "#26A6AE", fontSize: "12px", fontWeight: "400", cursor: "pointer" }}
      >
        Clear All
      </Typography>
    </Stack>
  );
};
